import { render } from "./QbSad.vue?vue&type=template&id=e78a8532"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QbSad.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e78a8532"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e78a8532', __exports__)) {
    api.reload('e78a8532', __exports__)
  }
  
  module.hot.accept("./QbSad.vue?vue&type=template&id=e78a8532", () => {
    api.rerender('e78a8532', render)
  })

}


export default __exports__